import React from "react";
import styled from "styled-components";
import classnames from "classnames";
import { cropImageSize, isMealSoldCheck } from "../../../utils/functions";
import { ReactComponent as Cross } from "./../../atoms/icons/cross.svg";
import { ReactComponent as Plus } from "./../../atoms/icons/plus-small.svg";
import { ReactComponent as Minus } from "./../../atoms/icons/minus-small.svg";
import _ from "lodash";
import ModalWindow from "./../../molecules/Modal";

const Wrap = styled.div`
  position: relative;
  min-height: 110px;
  border-bottom: 1px solid #e6e6e6;

  &.disabled::before,
  &.sold::before {
    content: "";
    position: absolute;
    background-color: rgba(223, 79, 48, 0.05);
    box-shadow: 0 0 0 1px rgba(223, 79, 48, 0.28);
    top: 8px;
    left: 0;
    right: 0;
    bottom: 8px;
    border-radius: 3px;
  }

  &.sold {
    img {
      opacity: 0.3;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  top: 11px;
  left: 0;
  width: 25px;
`;

const PlusButton = styled.button`
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  user-select: none;
  text-align: center;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const MinusButton = styled.button`
  width: 24px;
  height: 24px;
  margin-top: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  user-select: none;
  text-align: center;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const Input = styled.input`
  width: 24px;
  margin: 4px 0;
  padding: 0;
  border: none;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.3px;
  text-align: center;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const Inner = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 10px 40px 10px 30px;
`;

const Title = styled.h4`
  margin: 10px 0 7px 0;
  padding: 0;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: 0.31px;
`;

const Details = styled.button`
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  user-select: none;
  color: #000000;
  outline: none;
  box-shadow: none;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: var(--color-primary);
  text-decoration: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const ImageWrap = styled.div`
  position: relative;
`;

const OverlayMessage = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  right: 0;
  left: 0;
  padding: 3px 3px 2px 4px;
  border-radius: 7px;
  background: var(--color-primary);
  font-size: 12px;
  color: #fff;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: center;
  transform: translate(0, -50%);
`;

const Image = styled.img`
  display: block;
  position: relative;
  z-index: 1;
  width: 68px;
  min-width: 68px;
  height: auto;
`;

const DescriptionWrap = styled.div`
  padding-left: 8px;
`;

const Delete = styled.button`
  width: 25px;
  height: 25px;
  position: absolute;
  top: 12px;
  right: 2px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  user-select: none;
  opacity: 0.5;
  color: #000000;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg path {
    fill: #000000;
  }
`;

const Alert = styled.div`
  position: absolute;
  z-index: 3;
  right: 4px;
  bottom: 12px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--color-primary);
  font-size: 11px;
  line-height: 16px;
  color: #fff;
  text-align: center;
  cursor: pointer;

  span {
    position: relative;
  }

  &:hover div {
    opacity: 1;
    visibility: visible;
    transition: 0.3s ease all;
  }
`;

const Tooltip = styled.div`
  opacity: 0;
  visibility: hidden;
  width: 125px;
  position: absolute;
  z-index: 2;
  transform: translate(0, -50%);
  top: 50%;
  right: 28px;
  padding: 3px 16px;
  border-radius: 4px;
  background: #5c5c5c;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  transition: 0.3s ease all;

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    transform: translate(0, -50%);
    top: 50%;
    left: 100%;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-color: transparent transparent transparent #5c5c5c;
  }
`;

class SidebarItem extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
    };
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  increment = () => {
    if (this.props.excluded) return false;
    let quantitySelected = parseInt(this.props.quantity);
    if (quantitySelected <= 29) this.handleQuantityChange(quantitySelected + 1);
  };
  decrement = () => {
    if (this.props.excluded) return false;
    let quantitySelected = parseInt(this.props.quantity);
    this.handleQuantityChange(quantitySelected - 1 < 0 ? 0 : quantitySelected - 1);
  };

  handleChange = (event) => {
    this.handleQuantityChange(event.target.value < 0 ? 0 : event.target.value);
  };

  handleDeleteItem = () => {
    let type = this.getItemType();
    this.props.handleDeleteItem(this.props.id, type);
  };

  getItemType = () => {
    let type;

    this.props.tags.forEach((tag) => {
      if (tag.toLowerCase().includes("breakfast")) {
        type = "breakfast";
        return false;
      } else if (tag.toLowerCase().includes("entrée")) {
        type = "entree";
        return false;
      }
    });

    return type;
  };

  handleQuantityChange(quantity) {
    let type = this.getItemType();
    this.props.handleMealChange({
      id: this.props.id,
      quantity: quantity,
      title: this.props.title,
      image: this.props.image,
      type: type,
      mealBoughtQuantity: this.props.mealBoughtQuantity,
      stockCapacity: this.props.stockCapacity,
    });
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  };

  render() {
    const { id, title, quantity, images, image, excluded, selectedDiet, tags, mealBoughtQuantity, stockCapacity, charge } = this.props;

    let _charge = { ...charge };
    const { modalIsOpen } = this.state;
    const excludedTooltipTexts = () => {
      let selectedExclusions = [...this.props.selectedExclusions];
      let tootipTexts = [];

      selectedExclusions.push(selectedDiet);

      tags.forEach(function (item) {
        selectedExclusions.forEach(function (excludedItem) {
          if (item.toLowerCase().includes(excludedItem.toLowerCase())) tootipTexts.push(excludedItem);
        });
      });

      return _.join(tootipTexts, ", ");
    };

    const isSold = isMealSoldCheck({
      id: id,
      mealBoughtQuantity: mealBoughtQuantity,
      stockCapacity: stockCapacity,
      quantity: quantity,
      charge: _charge,
    });

    const optimizedImage = cropImageSize(image, "136");
    return (
      <Wrap className={classnames({ disabled: excluded }, { sold: isSold })}>
        {excluded && (
          <Alert>
            <span>!</span>
            <Tooltip>Contains {excludedTooltipTexts()}</Tooltip>
          </Alert>
        )}
        <Controls>
          <PlusButton onClick={this.increment}>
            <Plus />
          </PlusButton>
          <Input readOnly value={quantity} onChange={this.handleChange} className="cnt-input" />
          <MinusButton onClick={this.decrement}>
            <Minus />
          </MinusButton>
        </Controls>
        <Inner>
          <ImageWrap>
            <Image src={optimizedImage} loading="lazy" decoding="async" width="68" height="68" alt={title} />
            {isSold && (
              <OverlayMessage>
                <b>Sold out</b>
              </OverlayMessage>
            )}
          </ImageWrap>
          <DescriptionWrap>
            <Title>{title}</Title>
            <Details onClick={this.openModal}>View details</Details>
          </DescriptionWrap>
          <Delete onClick={this.handleDeleteItem}>
            <Cross />
          </Delete>
        </Inner>
        <ModalWindow productId={this.props.productId || id} images={images} modalIsOpen={modalIsOpen} closeModal={this.closeModal} />
      </Wrap>
    );
  }
}

export default SidebarItem;
 